export default __webpack_public_path__ + "b0e93cd8224c77296d5bafae4290ad30.svg";